import styled from '@emotion/styled';

const WhyBookStyle = styled('div')`
    font-size: 16px;
    line-height: 1.3;
    .box-why {
        .why-title {
            font-weight: 700;
            margin-bottom: 12px;
        }
        .link {
            color: rgb(26, 145, 255);
            cursor: pointer;
            text-decoration-line: underline;
        }
    }

    @media screen and (min-width: 1200px) {
        .box-why {
            max-width: 203px;
        }
        .ant-row {
            .ant-col:first-child .why-detail {
            max-width: 183px;
            }
        }
    }

    @media screen and (max-width: 767px) {
        .box-why {
            margin-bottom: 24px;
        }
    }
`;
export default WhyBookStyle;
